import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M4.25,16 C3.83578644,16 3.5,15.6642136 3.5,15.25 C3.5,14.8357864 3.83578644,14.5 4.25,14.5 L11.75,14.5 C12.1642136,14.5 12.5,14.8357864 12.5,15.25 C12.5,15.6642136 12.1642136,16 11.75,16 L4.25,16 Z M4.25,11.5 C3.83578644,11.5 3.5,11.1642136 3.5,10.75 C3.5,10.3357864 3.83578644,10 4.25,10 L11.75,10 C12.1642136,10 12.5,10.3357864 12.5,10.75 C12.5,11.1642136 12.1642136,11.5 11.75,11.5 L4.25,11.5 Z M4.25,7 C3.83578644,7 3.5,6.66421356 3.5,6.25 C3.5,5.83578644 3.83578644,5.5 4.25,5.5 L8.75,5.5 C9.16421356,5.5 9.5,5.83578644 9.5,6.25 C9.5,6.66421356 9.16421356,7 8.75,7 L4.25,7 Z M2,0.75 L14,0.75 C15.1045695,0.75 16,1.6454305 16,2.75 L16,18.75 C16,19.8545695 15.1045695,20.75 14,20.75 L2,20.75 C0.8954305,20.75 0,19.8545695 0,18.75 L0,2.75 C0,1.6454305 0.8954305,0.75 2,0.75 Z M2,3.75 L2,17.75 C2,18.3022847 2.44771525,18.75 3,18.75 L13,18.75 C13.5522847,18.75 14,18.3022847 14,17.75 L14,3.75 C14,3.19771525 13.5522847,2.75 13,2.75 L3,2.75 C2.44771525,2.75 2,3.19771525 2,3.75 Z"
      transform="translate(4 1)"
      fill={fill}
    />
  </g>
);

export default Icon;
